import { render } from "./ProjectList.vue?vue&type=template&id=00f06ff8&scoped=true&ts=true"
import script from "./ProjectList.vue?vue&type=script&lang=ts"
export * from "./ProjectList.vue?vue&type=script&lang=ts"

import "./ProjectList.vue?vue&type=style&index=0&id=00f06ff8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f06ff8"]])

export default __exports__